import React from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { SwiperSlide } from 'swiper/react'
import { CarouselFormItemWrapper, CarouselFormItem } from '../../swiperNav/style'
import { SwiperNav, ICarouselNavItems } from '..'
import '../navStyle.css'

export interface SwiperWrapperProps {
  carouselNavItems: ICarouselNavItems[]
  breakpoints: any
  offset: number
  containerId?: string
  swiperId?: string
}

export const SwiperNavForm = ({
  carouselNavItems,
  breakpoints,
  offset,
  containerId,
  swiperId = 'nav-form-default'
}: SwiperWrapperProps): JSX.Element => {
  const formSections = <>{carouselNavItems.map((item, index) => {
    return (
      <SwiperSlide key={index}>
        <CarouselFormItemWrapper>
          <CarouselFormItem offset={offset} activeClass="activeNavItem" containerId={containerId} spy to={`${item.itemHash}`}>
            {item.name}
          </CarouselFormItem>
        </CarouselFormItemWrapper>
      </SwiperSlide>
    )
  })}
  </>

  return (
    <SwiperNav breakpoints={breakpoints} sections={formSections} swiperId={swiperId} />
  )
}
